import { Pipe, PipeTransform, inject } from '@angular/core';

import { SortingService } from '@shared/services/sorting.service';

@Pipe({ name: 'sort', standalone: true })
export class SortPipe implements PipeTransform {
  readonly #sortingService = inject(SortingService);

  transform<T>(
    list: readonly T[] | null | undefined,
    propertyName: string,
    direction: 'asc' | 'desc' = 'asc',
    caseSensitive = false
  ): T[] {
    if (!list?.length) {
      return [];
    }
    return this.#sortingService.sort(
      list,
      propertyName,
      direction,
      caseSensitive
    );
  }
}
